module.exports = global["Nis"] = require("-!e:\\build\\Roadmap-Release-19.1\\Source\\Nis.WebAgent\\frontend\\node_modules\\awesome-typescript-loader\\dist\\entry.js??ref--1!e:\\build\\Roadmap-Release-19.1\\Source\\Nis.WebAgent\\frontend\\node_modules\\tslint-loader\\index.js!.\\Nis.ts");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?Nis!./src/globals/Nis.ts-exposed
// module id = 232
// module chunks = 8 14